import deepEqual from '@schibsted-nmp/search-frontend-utils/deepEqual.js';
import { Store, useStore } from '@tanstack/react-store';
import type { SearchParams } from '../state/AppStateTypes';

const EMPTY_SEARCH_PARAMS: SearchParams = {};

type SearchParamsStore = {
    searchParams: SearchParams;
};

const store = new Store<SearchParamsStore>({
    searchParams: EMPTY_SEARCH_PARAMS,
});

function setSearchParams(searchParams: SearchParams = EMPTY_SEARCH_PARAMS) {
    store.setState((state) => {
        const isSameSearchParams = deepEqual(state.searchParams, searchParams);
        return isSameSearchParams ? state : { ...state, searchParams };
    });
}

export function useSearchParams() {
    const searchParams = useStore(store, (state) => state.searchParams);

    // This hook returns a stable reference to the search params object, but it
    // opens up for unintended side effects if the object is mutated elsewhere.
    return { searchParams, setSearchParams };
}
